<div class="d-flex flex-column justify-content-center">
    <p style="font-size:15px;font-weight: 500;">
        How was your experience?
    </p>
    <div class="row">
        <div class="col-2" *ngFor="let button of buttons; let i = index">
            <button type="button" class="btn btn-outline-primary"
                    (click)="setEduction(i)" style="margin-bottom: 10px;width:42px;height: 42px;"
                    [ngStyle]="{ 'background-color': buttons[i].isClickable ? '#FFFFFF' : '#E4E5E8' }"
            >
                      <img src="{{buttons[i].URL}}" />
            </button>
        </div>
    </div>
</div>
